import React, { useEffect, useState } from 'react';
import { Box, Grid, Paper, Skeleton, Typography } from '@mui/material';

export const NotificacionItem = ({
  idSolicitud,
  tipoNotificacion,
  numeroNotificacion,
  codigoTipoNotificacion,
  loading = false,
  ...props
}) => {
  const [texto, setTexto] = useState(
    'Ya puede consultar el estado de su trámite N.º ' + idSolicitud + '.',
  );

  useEffect(() => {
    if (codigoTipoNotificacion === 'RecetaMedicaIfx') {
      setTexto('Notificación de la Receta Médica #' + idSolicitud);
    }

    if (codigoTipoNotificacion === 'PrescripcionElectronica') {
      setTexto('Podés consultar el documento emitido N.º ' + idSolicitud + ' en Mi OSER.');
    }

    if (codigoTipoNotificacion === 'ORDEN_AUTOMATICA') {
      setTexto('Ya podés consultar la orden generada N.º ' + idSolicitud + '.');
    }
  }, [idSolicitud]);

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        margin: 'auto',
        flexGrow: 1,
        backgroundColor: '#e3ecf7',
        ...props?.sx,
      }}
    >
      <Grid containerspacing={2}>
        <Grid item xs={12} sm container wrap='nowrap'>
          <Grid item xs container direction='column' spacing={2}>
            <Grid item xs>
              {loading ? (
                <>
                  <Skeleton variant='text' width={150} height={28} />
                  <Skeleton variant='text' width={'100%'} height={20} />
                  <Skeleton variant='text' width={150} height={20} />
                </>
              ) : (
                <>
                  <Typography gutterBottom variant='subtitle1' component='div'>
                    <Box sx={{ fontWeight: 'bold', textTransform: 'capitalize' }}>
                      {tipoNotificacion.toLowerCase()}
                    </Box>
                  </Typography>
                  <Typography variant='body2' color='text.secondary' style={{ textWrap: 'wrap' }}>
                    {texto}
                  </Typography>
                </>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};
